import React, { useState, useEffect, useCallback } from 'react';
import useTicketPurchase from './hooks/useTicketPurchase';
import TicketPurchaseModal from './TicketPurchaseModal';
import MembershipRequiredModal from '../../pages/ownerVerification/components/MembershipRequiredModal/MembershipRequiredModal';
import { toast, TOAST_POSITION } from '../../components/material/ToastPopup';

function TicketPurchaseWidget({ serviceName, saleUuid, onClose }) {
  const isMembership = window.loggedInUser?.isInit && window.loggedInUser?.getInfo()?.membership;
  const [loading, setLoading] = useState(false);

  const showToast = useCallback((msg) => {
    toast.error(msg, { position: TOAST_POSITION.BOTTOM_CENTER });
  }, []);

  const { ticketProducts, loadBuyable, createOrder } = useTicketPurchase({ serviceName, showToast });

  useEffect(() => {
    loadBuyable();
  }, []);

  const handlePurchase = useCallback(async (product) => {
    setLoading(true);
    const orderData = await createOrder(product);
    if (!orderData) { setLoading(false); return; }

    const currentSaleUuid = saleUuid;

    window.closePopup('ticket-purchase-root');

    window.openRequestPayment({
      order_uuid: orderData.order_uuid,
      product: {
        name: orderData.order_name,
        price: orderData.total_amount,
      },
      mode: window.REQUEST_PAYMENT_PARAMS?.MODE?.PAYMENT,
      support: window.REQUEST_PAYMENT_PARAMS?.SUPPORT?.ALL,
      callback: () => {
        if (currentSaleUuid) {
          window.openOwnerVerification?.({ saleUuid: currentSaleUuid });
        }
      },
    });
  }, [createOrder, saleUuid]);

  if (!isMembership) {
    return (
      <MembershipRequiredModal
        onConfirm={() => {
          onClose?.();
          window.openMembershipInfoPage?.();
        }}
        onClose={onClose}
      />
    );
  }

  return (
    <TicketPurchaseModal
      isOpen
      products={ticketProducts}
      loading={loading}
      onPurchase={handlePurchase}
      onCancel={onClose}
      onClose={onClose}
    />
  );
}

export default TicketPurchaseWidget;
